














import Vue from "vue"
import { CsvImportResponse, CsvImportResponseEntity, CsvStatus } from "@/model/dto/csv-upload.ts"
import { FieldDescriptor, FieldTypeEnum } from "@/model/entity/field-descriptor"
import { DatatableEntity } from "@/model/entity/datatable-entity"
import { Shipment } from "@/model/entity/shipment/shipment"
import { ShipmentReceiver } from "@/model/entity/shipment/shipment-receiver"
import { ShipmentDeskDelivery } from "@/model/entity/shipment/shipment-desk-delivery"
import { ShipmentOptions } from "@/model/entity/shipment/shipment-options"
import { ShipmentIdCheck } from "@/model/entity/shipment/shipment-id-check"
import { ShipmentCOD } from "@/model/entity/shipment/shipment-cod"
import { Parcel } from "@/model/entity/parcel/parcel"
import { ParcelCOD } from "@/model/entity/parcel/parcel-cod"
import { plainToClass } from "class-transformer"
import Upload, { IUpload } from "@/components/upload/Upload.vue"
import { ShipmentParcelShop } from "@/model/entity/shipment/shipment-parcel-shop"
import { ParcelGoods } from "@/model/entity/shipment/parcel-goods"
import { ParcelLimitedQuantity } from "@/model/entity/parcel/parcel-limited-quantity"

class ParcelCsvDto extends DatatableEntity implements CsvImportResponseEntity {
  id: number

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.parcel.upload.report.parcel_type",
    columnWidth: "100"
  })
  parcelType: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.parcel.upload.report.parcel_weight",
    columnWidth: "110"
  })
  parcelWeight: string

  codValue: string[]

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.parcel.upload.report.cod_value",
    columnWidth: "90"
  })
  get prettyCodValue(): string {
    if (!exists(this.codValue) || this.codValue.length === 0) {
      return ""
    }
    return this.codValue.reduce((accumulator, currentValue) => accumulator + ", " + currentValue)
  }

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.parcel.upload.report.cod_reference_number",
    columnWidth: "110"
  })
  codReferenceNumber: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "new_parcel.return_of_document",
    columnWidth: "110"
  })
  returnOfDocument: any

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.parcel.upload.report.customer_parcel_reference",
    columnWidth: "120"
  })
  customerParcelReference: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.parcel.upload.report.address_reference",
    columnWidth: "130"
  })
  addressReference: string

  @FieldDescriptor({ fieldType: FieldTypeEnum.TEXT, fieldPrettyName: "entity.parcel.upload.report.receiver_name" })
  receiverName: string

  @FieldDescriptor({ fieldType: FieldTypeEnum.TEXT, fieldPrettyName: "entity.parcel.upload.report.receiver_name_2" })
  receiverName2: string

  @FieldDescriptor({ fieldType: FieldTypeEnum.TEXT, fieldPrettyName: "entity.parcel.upload.report.receiver_address_1" })
  receiverAddress1: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.parcel.upload.report.receiver_house_number"
  })
  receiverHouseNumber: string

  @FieldDescriptor({ fieldType: FieldTypeEnum.TEXT, fieldPrettyName: "entity.parcel.upload.report.receiver_address_2" })
  receiverAddress2: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.parcel.upload.report.receiver_country_format",
    columnWidth: "125"
  })
  receiverCountryFormat: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.parcel.upload.report.receiver_postal_code",
    columnWidth: "120"
  })
  receiverPostalCode: string

  @FieldDescriptor({ fieldType: FieldTypeEnum.TEXT, fieldPrettyName: "entity.parcel.upload.report.receiver_city" })
  receiverCity: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.parcel.upload.report.receiver_phone_number",
    columnWidth: "120"
  })
  receiverPhoneNumber: string

  @FieldDescriptor({ fieldType: FieldTypeEnum.TEXT, fieldPrettyName: "entity.parcel.upload.report.fax" })
  fax: string

  @FieldDescriptor({ fieldType: FieldTypeEnum.TEXT, fieldPrettyName: "entity.parcel.upload.report.email" })
  email: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.parcel.upload.report.remark_for_delivery",
    columnWidth: "95"
  })
  remarkForDelivery: string

  @FieldDescriptor({ fieldType: FieldTypeEnum.TEXT, fieldPrettyName: "entity.parcel.upload.report.idm" })
  idm: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.parcel.upload.report.id_check_reciever_name",
    columnWidth: "125"
  })
  idCheckReceiverName: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.parcel.upload.report.id_check_id_number",
    columnWidth: "95"
  })
  idCheckIdNumber: string

  @FieldDescriptor({ fieldType: FieldTypeEnum.TEXT, fieldPrettyName: "entity.parcel.upload.report.number_of_parcels" })
  numberOfParcels: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.parcel.upload.report.predict_service",
    columnWidth: "125"
  })
  predictService: string

  @FieldDescriptor({ fieldType: FieldTypeEnum.TEXT, fieldPrettyName: "entity.parcel.upload.report.cod_type" })
  codType: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.parcel.upload.report.desk_delivery",
    columnWidth: "115"
  })
  deskDelivery: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.parcel.upload.report.department",
    columnWidth: "110"
  })
  department: string

  @FieldDescriptor({ fieldType: FieldTypeEnum.TEXT, fieldPrettyName: "entity.parcel.upload.report.building" })
  building: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.parcel.upload.report.floor_number",
    columnWidth: "110"
  })
  floorNumber: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.parcel.upload.report.dimension",
    columnWidth: "120"
  })
  dimension: string

  parcelGoods: ParcelGoods

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "new_parcel.temp_min",
    columnWidth: "120"
  })
  get tempMin(): string {
    if (!exists(this.parcelGoods)) {
      return ""
    }
    return this.parcelGoods.tempMin
  }

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "new_parcel.temp_max",
    columnWidth: "120"
  })
  get tempMax(): string {
    if (!exists(this.parcelGoods)) {
      return ""
    }
    return this.parcelGoods.tempMax
  }

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "new_parcel.limit_date",
    columnWidth: "120"
  })
  limitDate: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "user_administration.description",
    columnWidth: "120"
  })
  get description(): string {
    if (!exists(this.parcelGoods)) {
      return ""
    }
    return this.parcelGoods.description
  }

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "new_parcel.lqUnno",
    columnWidth: "120"
  })
  lqUnno: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "new_parcel.lqPgGroup",
    columnWidth: "120"
  })
  lqPgGroup: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "new_parcel.lqCCode",
    columnWidth: "120"
  })
  lqCCode: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "new_parcel.lqClass",
    columnWidth: "120"
  })
  lqClass: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "new_parcel.lqSubWeight",
    columnWidth: "120"
  })
  lqSubweight: string

  csvStatus: CsvStatus
  statusDescription: string
  serviceCode: string
  serviceBackCode: string
  shipmentParcelShop: ShipmentParcelShop
  shipmentCOD: ShipmentCOD
  codParcelValues: number[]

  constructor(
    parcelType: string,
    parcelWeight: string,
    codValue: string[],
    codReferenceNumber: string,
    customerParcelReference: string,
    addressReference: string,
    receiverName: string,
    receiverName2: string,
    receiverAddress1: string,
    receiverHouseNumber: string,
    receiverAddress2: string,
    receiverCountryFormat: string,
    receiverPostalCode: string,
    receiverCity: string,
    receiverPhoneNumber: string,
    fax: string,
    email: string,
    remarkForDelivery: string,
    idm: string,
    idCheckReceiverName: string,
    idCheckIdNumber: string,
    numberOfParcels: string,
    predictService: string,
    codType: string,
    deskDelivery: string,
    department: string,
    building: string,
    floorNumber: string,
    csvStatus: CsvStatus,
    statusDescription: string,
    serviceCode: string,
    returnOfDocument: string,
    serviceBackCode: string,
    shipmentParcelShop: ShipmentParcelShop,
    shipmentCOD: ShipmentCOD,
    codParcelValues: number[],
    parcelGoods: ParcelGoods,
    id: number
  ) {
    super()
    this.parcelType = parcelType
    this.parcelWeight = parcelWeight
    this.codValue = codValue
    this.codReferenceNumber = codReferenceNumber
    this.customerParcelReference = customerParcelReference
    this.addressReference = addressReference
    this.receiverName = receiverName
    this.receiverName2 = receiverName2
    this.receiverAddress1 = receiverAddress1
    this.receiverHouseNumber = receiverHouseNumber
    this.receiverAddress2 = receiverAddress2
    this.receiverCountryFormat = receiverCountryFormat
    this.receiverPostalCode = receiverPostalCode
    this.receiverCity = receiverCity
    this.receiverPhoneNumber = receiverPhoneNumber
    this.fax = fax
    this.email = email
    this.remarkForDelivery = remarkForDelivery
    this.idm = idm
    this.idCheckReceiverName = idCheckReceiverName
    this.idCheckIdNumber = idCheckIdNumber
    this.numberOfParcels = numberOfParcels
    this.predictService = predictService
    this.codType = codType
    this.deskDelivery = deskDelivery
    this.department = department
    this.building = building
    this.floorNumber = floorNumber
    this.csvStatus = csvStatus
    this.statusDescription = statusDescription
    this.serviceCode = serviceCode
    this.returnOfDocument = returnOfDocument
    this.serviceBackCode = serviceBackCode
    this.shipmentParcelShop = shipmentParcelShop
    this.shipmentCOD = shipmentCOD
    this.codParcelValues = codParcelValues
    this.parcelGoods = parcelGoods
    this.id = id
  }
}

export default Vue.extend({
  components: { Upload },
  data() {
    return {
      fields: ParcelCsvDto.getFieldDescriptionList()
    }
  },
  methods: {
    submit(fileResponseList: CsvImportResponse<ParcelCsvDto>[]) {
      const vm = this
      const newParcelRequestList = fileResponseList
        .flatMap(fileResponse => {
          return fileResponse.items
        })
        .map((parcelCsvDto: ParcelCsvDto) => {
          const receiver = new ShipmentReceiver(
            parcelCsvDto.receiverName,
            parcelCsvDto.receiverCountryFormat,
            parcelCsvDto.receiverPostalCode,
            parcelCsvDto.receiverCity,
            parcelCsvDto.receiverAddress1,
            parcelCsvDto.receiverPhoneNumber,
            parcelCsvDto.email,
            parcelCsvDto.receiverPhoneNumber,
            parcelCsvDto.receiverName2,
            parcelCsvDto.receiverHouseNumber
          )

          const deskDelivery = new ShipmentDeskDelivery(
            parcelCsvDto.floorNumber,
            parcelCsvDto.building,
            parcelCsvDto.department
          )

          const parcelLimitedQuantity = new ParcelLimitedQuantity(parcelCsvDto.lqUnno,
          parcelCsvDto.lqPgGroup, parcelCsvDto.lqCCode, parcelCsvDto.lqClass, parcelCsvDto.lqSubweight)

          const shipmentOptions = new ShipmentOptions(
            parcelCsvDto.returnOfDocument.length !== 0,
            parcelCsvDto.deskDelivery.length !== 0,
            parcelCsvDto.idCheckReceiverName.length !== 0 || parcelCsvDto.idCheckIdNumber.length !== 0,
            parcelCsvDto.predictService.length !== 0,
            false
          )

          const shipmentIdCheck = new ShipmentIdCheck(parcelCsvDto.idCheckReceiverName, parcelCsvDto.idCheckIdNumber)

          const codActive = exists(parcelCsvDto.shipmentCOD)

          const shipmentCod = parcelCsvDto.shipmentCOD

          const parcelGoods = parcelCsvDto.parcelGoods

          const shipment = new Shipment(
            Number(parcelCsvDto.numberOfParcels),
            parcelCsvDto.customerParcelReference,
            "CSV",
            parcelCsvDto.shipmentParcelShop,
            vm.$store.getters.shipmentSender(parcelCsvDto.remarkForDelivery),
            receiver,
            parcelCsvDto.deskDelivery.length === 0 ? undefined : deskDelivery,
            shipmentOptions.idCheck ? shipmentIdCheck : undefined,
            shipmentOptions,
            shipmentCod
          )

          const parcelList: Parcel[] = []

          for (let index = 0; index < Number(parcelCsvDto.numberOfParcels); index++) {
            let parcelCod: ParcelCOD | undefined
            if (codActive) {
              parcelCod = new ParcelCOD(parcelCsvDto.codParcelValues[index])
            }
            parcelList.push(
              new Parcel(
                Number(parcelCsvDto.parcelWeight) * 1000,
                parcelCsvDto.serviceCode,
                parcelCsvDto.serviceBackCode,
                index + 1,
                undefined,
                parcelCod,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                parcelCsvDto.addressReference,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                parcelCsvDto.dimension,
                parcelGoods,
                undefined,
                parcelLimitedQuantity
              )
            )
          }

          return {
            shipment: shipment,
            parcelList: parcelList,
            parcelCsvDto: parcelCsvDto
          }
        })

      vm.startLoad()
      vm.$http
        .post(
          "/parcel/multiple_parcel_request",
          newParcelRequestList.map(newParcelRequest => {
            return {
              shipment: newParcelRequest.shipment,
              parcelList: newParcelRequest.parcelList
            }
          })
        )
        .then(response => {
          vm.$message({
            message: this.$t("upload.parcel.valid_csv_lines").toString(),
            type: "info"
          })
          fileResponseList.forEach(fileResponse => (fileResponse.csvStatus = CsvStatus.UPLOAD_FINISHED))
          response.data.forEach((parcelResponse: any, index: number) => {
            newParcelRequestList[index].parcelCsvDto.csvStatus =
              parcelResponse.code === 0 ? CsvStatus.PROCESSED : CsvStatus.ERROR
            let message = parcelResponse.message
            if (parcelResponse.code === 0) {
              message += ` - ${parcelResponse.parcelList.length} `
              message += this.$t("upload.parcel.parcels_created")
            }
            newParcelRequestList[index].parcelCsvDto.statusDescription = message
          })
          vm.endLoad()
        })
        .catch(() => {
          vm.endLoad()
        })
    },
    uploadFile(fileData: FormData) {
      const vm = this
      const upload = vm.$refs.upload as IUpload

      vm.startLoad()
      this.$http
        .post("parcel/file_upload", fileData)
        .then(response => {
          response.data.forEach(
            (file: any) =>
              (file.items = file.items.map((raw: object, index: number) => {
                const item = plainToClass(ParcelCsvDto, raw)
                item.id = index
                return item
              }))
          )
          upload.fileResponseList.push(...response.data)

          vm.endLoad()
        })
        .catch(() => {
          vm.endLoad()
        })
    }
  }
})
